<script>
import Multiselect from 'vue-multiselect'

export default {
	name: 'HistoryFilters',
	components: { Multiselect },
	props: {
		// filters object owned by the parent (used with :filters.sync)
		filters: {
			type: Object,
			required: true,
		},
		statusOptions: {
			type: Array,
			default: () => [],
		},
		directionOptions: {
			type: Array,
			default: () => [],
		},
	},
	methods: {
		update(field, value) {
			this.$emit('update:filters', { ...this.filters, [field]: value })
		},
	},
}
</script>

<template>
	<div class="history-filters">
		<div class="history-filters__label">{{ $t('labels.filter') }}</div>
		<div class="history-filters__grid">
			<label class="search__label history-filters__field">
				<input
					:value="filters.searchNikad"
					type="text"
					:placeholder="$t('virtual_warehouse.history.search_by_nikad')"
					class="input-linck"
					@input="update('searchNikad', $event.target.value)"
				/>
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11 19a8 8 0 100-16 8 8 0 000 16zM21 21l-4.35-4.35" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
			</label>

			<label class="search__label history-filters__field">
				<input
					:value="filters.searchBin"
					type="text"
					:placeholder="$t('virtual_warehouse.history.search_by_bin')"
					class="input-linck"
					@input="update('searchBin', $event.target.value)"
				/>
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11 19a8 8 0 100-16 8 8 0 000 16zM21 21l-4.35-4.35" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
			</label>

			<multiselect
				:value="filters.status"
				:options="statusOptions"
				label="name"
				track-by="id"
				:clearOnSelect="false"
				:clear-on-select="false"
				:placeholder="$t('virtual_warehouse.history.select_status')"
				class="multiselect__check history-filters__field"
				@input="update('status', $event)"
			>
				<template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
				<template slot="noResult">{{ $t('components.not_found') }}</template>
			</multiselect>

			<multiselect
				:value="filters.direction"
				:options="directionOptions"
				label="name"
				track-by="id"
				:clearOnSelect="false"
				:clear-on-select="false"
				:placeholder="$t('virtual_warehouse.history.select_direction')"
				class="multiselect__check history-filters__field"
				@input="update('direction', $event)"
			>
				<template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
				<template slot="noResult">{{ $t('components.not_found') }}</template>
			</multiselect>

			<label class="history-filters__date">
				<span class="history-filters__date-label"
					>{{ $t('virtual_warehouse.history.date_from') }}:</span
				>
				<input
					:value="filters.dateFrom"
					type="date"
					class="input-linck"
					@input="update('dateFrom', $event.target.value)"
				/>
			</label>

			<label class="history-filters__date">
				<span class="history-filters__date-label"
					>{{ $t('virtual_warehouse.history.date_to') }}:</span
				>
				<input
					:value="filters.dateTo"
					type="date"
					class="input-linck"
					@input="update('dateTo', $event.target.value)"
				/>
			</label>
		</div>

		<div class="history-filters__actions">
			<button class="input-btn form__line--btn" @click="$emit('search')">
				{{ $t('button.find') }}
			</button>
			<button class="btn--link btn--link--secondary" @click="$emit('clear')">
				{{ $t('button.clear') }}
			</button>
		</div>
	</div>
</template>

<style scoped>
.history-filters__label {
	color: #475f84;
	font-size: 14px;
	font-weight: 700;
	line-height: 1;
	margin-bottom: 12px;
}

.history-filters__grid {
	display: grid;
	grid-template-columns: repeat(6, minmax(0, 1fr));
	gap: 10px;
}

.history-filters__field {
	width: 100%;
}

/* Unify all field controls to match the design: light border, 10px radius, 44px height */
.history-filters ::v-deep .search__label input[type='text'] {
	height: 42px;
	border: 1px solid #e3eaf3;
	border-radius: 10px;
	padding: 0 38px 0 14px;
	font-size: 14px;
	color: #2b3a55;
}
.history-filters ::v-deep .search__label {
	display: block;
}
.history-filters ::v-deep .search__label svg {
	right: 14px;
	top: 0;
	bottom: 0;
	margin: auto 0;
	transform: none;
	width: 18px;
	height: 18px;
}
.history-filters ::v-deep .search__label input[type='text']::placeholder {
	color: #98a6bd;
}

.history-filters ::v-deep .multiselect,
.history-filters ::v-deep .multiselect__tags {
	min-height: 42px;
}
.history-filters ::v-deep .multiselect__tags {
	display: flex;
	align-items: center;
	border: 1px solid #e3eaf3;
	border-radius: 10px;
	padding: 0 40px 0 14px;
}
.history-filters ::v-deep .multiselect__single,
.history-filters ::v-deep .multiselect__input {
	font-size: 14px;
	color: #2b3a55;
	margin: 0;
	padding: 0;
	background: transparent;
	line-height: 1.2;
}
.history-filters ::v-deep span.multiselect__placeholder {
	color: #98a6bd;
	font-size: 14px;
	margin: 0;
	padding: 0;
}
.history-filters ::v-deep .multiselect__select {
	height: 42px;
	width: 38px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0;
}
.history-filters ::v-deep .multiselect__select::before {
	content: '';
	position: static;
	top: auto;
	margin: 0;
	border: none;
	width: 16px;
	height: 16px;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none'%3E%3Cpath d='M4 6l4 4 4-4' stroke='%23157FEE' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
	background-repeat: no-repeat;
	background-position: center;
}

.history-filters__date {
	display: flex;
	align-items: center;
	gap: 6px;
	background: #ffffff;
	border: 1px solid #e3eaf3;
	border-radius: 10px;
	padding: 0 12px;
	height: 42px;
}

.history-filters__date-label {
	color: #98a6bd;
	font-size: 13px;
	white-space: nowrap;
}

.history-filters__date .input-linck {
	border: none !important;
	background: transparent !important;
	padding: 0 !important;
	height: auto !important;
	box-shadow: none !important;
	color: #2b3a55;
	width: 100%;
}

.history-filters__date input[type='date']::-webkit-datetime-edit,
.history-filters__date input[type='date']::-webkit-datetime-edit-text,
.history-filters__date input[type='date']::-webkit-datetime-edit-day-field,
.history-filters__date input[type='date']::-webkit-datetime-edit-month-field,
.history-filters__date input[type='date']::-webkit-datetime-edit-year-field {
	color: #98a6bd;
}

.history-filters__date input[type='date']::-webkit-calendar-picker-indicator {
	width: 18px;
	height: 18px;
	cursor: pointer;
	opacity: 1;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='%23157FEE' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='4' width='18' height='18' rx='2'/%3E%3Cpath d='M16 2v4M8 2v4M3 10h18'/%3E%3C/svg%3E");
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
}

.history-filters__actions {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 10px;
}

/* Filter buttons per design: padding 12/30, radius 10, white Montserrat label */
.history-filters__actions .form__line--btn,
.history-filters__actions .btn--link {
	padding: 12px 30px;
	border-radius: 10px;
	font-family: 'Montserrat', sans-serif;
	font-weight: 500;
	font-size: 14px;
	line-height: 1.2;
}
.history-filters__actions .form__line--btn {
	background: #00e096;
}
.history-filters__actions .btn--link--secondary {
	background: #475f84;
}

@media (max-width: 1200px) {
	.history-filters__grid {
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}
}

@media (max-width: 768px) {
	.history-filters__grid {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
}

@media (max-width: 520px) {
	.history-filters__grid {
		grid-template-columns: 1fr;
	}
}
</style>
